var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-class"},_vm._l((_vm.items),function(item){return _c('div',{class:{ 'circle circle__dark': !_vm.isLight, 'circle circle__light': _vm.isLight }})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }